import * as StringUtils from '@packages/utilities/string-utils';
import SharedConfig from '@packages/systems/core/constants/SharedConfig';
import {hasGuid} from '@packages/systems/core/utils/UrlUtils';

/**
 * Decomposes an upload URL to known parts.
 * @param  {String} fullUrl   The full absolute URL to the image, e.g. "https://z9x9v2t5.ssl.hwcdn.net/webflow-prod-assets/527b624390f73dd479000137/528c8381636c8a2206000763_droptooltip.png"
 * @return {Object}           The image details.
 * NOTE: This may only be used to get the guid from the url
 */
export const getUploadData = function (fullUrl: string): {
  guid: string;
  url: string;
  fileName: string;
  origFileName: string;
} {
  const fileName = StringUtils.strRightBack(fullUrl, '/');
  let origFileName;
  let guid;
  const sharedPaths = SharedConfig.paths;

  if (fileName === sharedPaths.EXAMPLE_IMG_NAME) {
    guid = sharedPaths.EXAMPLE_IMG_ID;
    origFileName = sharedPaths.EXAMPLE_IMG_NAME;
  } else if (fileName === sharedPaths.EXAMPLE_BG_NAME) {
    guid = sharedPaths.EXAMPLE_BG_ID;
    origFileName = sharedPaths.EXAMPLE_BG_NAME;
  } else if (hasGuid(fileName)) {
    guid = StringUtils.strLeft(fileName, '_');

    origFileName = StringUtils.strRight(fileName, '_');
  } else {
    // Fallback is to use the filename as a GUID
    // This is necessary for really old sites created with the Tutorial template
    guid = StringUtils.slugify(fileName);
    origFileName = fileName;
  }

  const uploadInfo = {
    guid,
    url: fullUrl,
    fileName,
    origFileName: origFileName || fileName,
  } as const;

  return uploadInfo;
};
